import * as React from 'react';
import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgFileFilled = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path fill="#2D2E2E" d="M16 16H8v2h8v-2ZM16 12H8v2h8v-2Z" />
    <path
      fill="#2D2E2E"
      d="M20 6.59 15.41 2H4v20h16V10h-2v10H6V4h8v4h6V6.59Z"
    />
  </svg>
);
export default SvgFileFilled;
